import { combineReducers } from '@reduxjs/toolkit'

import batteryOverviewReducer from '~/app/batteries/slice'
import chargerOverviewReducer from '~/app/chargers/slice'
import v2DashboardReducer from '~/app/dashboard/v2/slice'
import reportsReducer from '~/app/reports/slice'
import firmwareErrorReducer from '~/app/settings/chargers/slice'
import siteOverviewReducer from '~/app/sites/slice'
import vehicleOverviewReducer from '~/app/vehicles/slice'
import { reducer as serviceReducers } from '~/data/api/client/reducer'
import assistantPanelReducer from '~/features/assistant-v2/panelSlice'
import desktopTabsReducer from '~/features/desktop/tabsSlice'
import viewedEntitiesReducer from '~/features/viewedEntities/slice'

import chargeAiSiteReducer from './slices/chargeAiSite'
import chargingOptimizationReducer from './slices/chargingOptimization'
import currentOrganizationReducer from './slices/currentOrg'
import demoModeReducer from './slices/demoMode'
import displayReducer from './slices/display'
import notificationOverlayReducer from './slices/notifications'
import tenant from './slices/tenant'
import vehicleReadinessReducer from './slices/vehicleReadiness'

const rootReducer = combineReducers({
  currentOrganization: currentOrganizationReducer,
  demoMode: demoModeReducer,
  'v2-dashboard': v2DashboardReducer,
  reports: reportsReducer,
  display: displayReducer,
  notificationOverlay: notificationOverlayReducer,
  chargeAiSite: chargeAiSiteReducer,
  chargingOptimization: chargingOptimizationReducer,
  desktopTabs: desktopTabsReducer,
  assistantPanel: assistantPanelReducer,
  viewedEntities: viewedEntitiesReducer,
  vehicleReadiness: vehicleReadinessReducer,
  batteryOverview: batteryOverviewReducer,
  chargerOverview: chargerOverviewReducer,
  firmwareError: firmwareErrorReducer,
  siteOverview: siteOverviewReducer,
  vehicleOverview: vehicleOverviewReducer,
  tenant,
  ...serviceReducers
})

export default rootReducer
